jQuery(document).ready(function($) {

	document.addEventListener( 'wpcf7mailsent', function(event) {
		if ('100' == event.detail.contactFormId) {
	    	$('.contact-split__form-wrapper').hide();
	    	$('.contact-split__form-success').show();
	  	}
	}, false );

	$('.styled-select select').change(function() {
		$(this).removeClass('inactive');
	});

});